import { message } from "antd";

let messageApiInstance = null;
let contextHolderInstance = null;

export const initMessageApi = () => {
  const [messageApi, contextHolder] = message.useMessage();
  messageApiInstance = messageApi;
  contextHolderInstance = contextHolder;
  return contextHolder;
};

export const showMessage = (type, content) => {
  if (!messageApiInstance) {
    console.error("⚠️ Message API not initialized. Call initMessageApi() in your root component.");
    return;
  }

  messageApiInstance.open({
    type,
    content,
    duration: 5,
  });
};

export const MESSAGE_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  LOADING: "loading",
};

export const showCatchError = (message) => {
  return showMessage(MESSAGE_TYPES.ERROR, message);
};
